export default __webpack_public_path__ + "static/media/metro-cross.fb5d8d69.svg";